import React from 'react';
import { techStack } from '../mock';

export const TechStack = () => {
  return (
    <section className="py-16 md:py-24 bg-[#111827] relative overflow-hidden border-y border-white/5">
      <div className="absolute inset-0 pro-grid opacity-20"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-block mb-3 md:mb-4">
            <span className="text-green-400 text-[10px] md:text-xs font-semibold uppercase tracking-wider">Technology Stack</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3 md:mb-4 px-4">
            Powered by <span className="text-green-400">Industry Standards</span>
          </h2>
        </div>

        {/* Tech Grid */}
        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-6">
          {techStack.map((tech, index) => (
            <div
              key={index}
              className="glass-card rounded-lg px-4 md:px-6 py-2 md:py-4 hover:border-green-500/20 transition-all duration-300"
              style={{ animation: 'fadeInUp 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards', animationDelay: `${index * 50}ms`, opacity: 0 }}
            >
              <div className="text-xs md:text-sm font-semibold text-white">
                {tech.name}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};